import { HttpContext, HttpContextToken } from '@angular/common/http';

/** When true, the global loading overlay ignores this request (background polling). */
export const SKIP_HTTP_LOADING = new HttpContextToken<boolean>(() => false);

export const silentHttpContext = new HttpContext().set(SKIP_HTTP_LOADING, true);
